import { Button, Checkbox, DatePicker, Modal, Table } from "antd";
import axios from "axios";
import moment from "moment/moment";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { api, endpoint } from "@/api";
import { userRole } from "@/constant";
import LoadingOverlay from "@/components/Shared/LoadingOverlay";
import { flare } from "@flareapp/js";

const DeviceData = () => {
  const [limit, setLimit] = useState(10);
  const [page, setPage] = useState(1);
  const [total, setTotal] = useState(0);
  const [deviceDetails, setDeviceDetails] = useState();
  const [isLoading, setIsLoading] = useState(false);
  const [readings, setReading] = useState([]);
  const [tableColumn, setTableColmn] = useState([]);
  const [modal1Open, setModal1Open] = useState(false);
  const [isDeleteLoading, setDeleteLoading] = useState(false);
  const [dateRange, setDateRange] = useState({ startDate: "", endDate: "" });
  const { userDetails } = useSelector((state) => state.user);

  const navigate = useNavigate();
  const Params = useParams();
  const deviceId = Params.deviceId;

  const deleteDeviceData = async () => {
    // console.log(dateRange);
    setDeleteLoading(true);
    try {
      const res = await axios.delete(`/device/device-data`, {
        withCredentials: true,
        params: { ...dateRange, device: deviceId },
      });
      Modal.info({
        title: res.data.message,
        onOk() {},
      });
    } catch {
      Modal.warn({
        title: "Something went wrong",
        onOk() {},
      });
      // apiNotification({ message: "Something went wrong", warn: true });
    }
    getDeviceData();
    setModal1Open(false);
    setDeleteLoading(false);
  };

  const getDevice = async () => {
    try {
      const response = await axios.get(`/device/` + deviceId, {
        withCredentials: true,
      });
      if (response) {
        setDeviceDetails(response.data?.result);
      }
    } catch (error) {
      flare.report(error);
      // eslint-disable-next-line no-console
      console.log(error);
    }
  };

  const generateTableHeader = (deviceParameters) => {
    if (tableColumn.length === 0) {
      setTableColmn([
        {
          title: "No.",
          width: "80px",
          render: (_, { sl }) => sl,
          align: "center",
        },
        {
          title: "Time",
          render: (_, row) => moment(row.date || row._id).format("DD/MM/YYYY hh:mm:ss a"),
          // width: "200px",
          align: "center",
        },
        ...deviceParameters.map(({ name, referenceName }) => {
          return {
            title: (
              <p>
                {name}
                {referenceName && (
                  <span>
                    <br /> ({referenceName})
                  </span>
                )}
              </p>
            ),
            render: (_, row) => (typeof row?.[name] === "number" ? Number(row?.[name]).toFixed(2) : "--"),
            align: "center",
          };
        }),
      ]);
    }
  };

  // getting the table data
  const getDeviceData = async () => {
    setIsLoading(true);
    try {
      let { results, count, deviceParameters } = await api.get(endpoint.get_devices_data, {
        params: { deviceId, limit, page, sortBy: "date", orderBy: "DESC" },
      });
      results = results.map((item, idx) => {
        item.sl = (page - 1) * limit + idx + 1;
        return item;
      });

      const tableHeader = deviceParameters.filter((item) => item !== "updatedAt");
      generateTableHeader(tableHeader);

      setReading(results);
      setTotal(count || 0);
    } catch (error) {
      flare.report(error);
      // eslint-disable-next-line no-console
      console.log(error);
    }
    setIsLoading(false);
  };

  const updateTruncatedDate = async (e) => {
    try {
      await api.put("/device/update-truncate", {
        deviceId,
        isTruncateDate: e.target.checked,
      });
      getDevice();
    } catch (error) {
      flare.report(error);
      // eslint-disable-next-line no-console
      console.log(error);
    }
  };

  useEffect(() => {
    getDevice();
  }, []);

  useEffect(() => {
    getDeviceData();
  }, [limit, page]);

  return (
    <div className="card p-3 m-md-3">
      <div className="row mb-2">
        <div className="col-md-6">
          <h5>Device Data Received</h5>
          <div className="d-flex">
            <b style={{ width: 110 }}> Business </b>
            <div>
              : {deviceDetails?.business ? `${deviceDetails?.business?.name} (${deviceDetails?.business?.id})` : "--"}
            </div>
          </div>
          <div className="d-flex">
            <b style={{ width: 110 }}> Site Location </b>
            <div> : {deviceDetails?.site?.name || "--"}</div>
          </div>
          <div className="d-flex">
            <b style={{ width: 110 }}> Device </b>
            <div> : {deviceDetails?.name || "--"}</div>
          </div>
        </div>
        <div className="col-md-6">
          <div className="d-flex justify-content-end">
            <div>
              {userDetails?.role === userRole.superAdmin ? (
                <>
                  <button onClick={() => setModal1Open(true)} className="btn btn-danger me-1">
                    Delete Data
                  </button>
                </>
              ) : (
                ""
              )}
              <button onClick={getDeviceData} className="btn btn-success me-1">
                Refresh
              </button>
              <button onClick={() => navigate(-1)} className="btn btn-secondary">
                Back
              </button>
            </div>
          </div>
          <div className="d-flex justify-content-end mt-3">
            <Checkbox checked={deviceDetails?.isTruncateDate} onChange={updateTruncatedDate}>
              Truncate Date
            </Checkbox>
          </div>
        </div>
      </div>
      <div>
        <LoadingOverlay isLoading={isLoading}>
          <Table
            dataSource={readings}
            columns={tableColumn}
            rowKey={(record) => record.id}
            scroll={{ x: true }}
            pagination={{
              defaultPageSize: limit,
              current: page,
              total,
              showSizeChanger: true,
              showLessItems: true,
              showQuickJumper: true,
              onShowSizeChange: (_, pageSize) => {
                setLimit(pageSize);
              },
              showTotal: (total, range) => `${range[0]}-${range[1]} of ${total}`,
              pageSizeOptions: [10, 20, 50],
              responsive: true,
            }}
            onChange={(pagination) => {
              setPage(pagination.current);
            }}
          />
        </LoadingOverlay>
        <Modal
          title="Delete Device Data"
          centered
          open={modal1Open}
          onCancel={() => setModal1Open(false)}
          footer={[
            <Button
              key="submit"
              type="primary"
              danger
              onClick={deleteDeviceData}
              size="large"
              loading={isDeleteLoading}
            >
              Confirm
            </Button>,
            <Button key="back" onClick={() => setModal1Open(false)} size="large">
              Cancel
            </Button>,
          ]}
        >
          <form>
            <div>
              <label className="d-block mb-2 mt-3" htmlFor="from">
                From{" "}
              </label>
              <DatePicker
                showTime
                onChange={(_, date) => setDateRange({ ...dateRange, startDate: date })}
                className=" w-100"
                format="DD-MM-YYYY, h:mm:ss a"
                size="large"
              />
            </div>
            <div>
              <label className="d-block mb-2 mt-3" htmlFor="to">
                To{" "}
              </label>
              <DatePicker
                showTime
                format="DD-MM-YYYY, h:mm:ss a"
                onChange={(_, date) => setDateRange({ ...dateRange, endDate: date })}
                className=" w-100"
                size="large"
              />
            </div>
          </form>
        </Modal>
      </div>
    </div>
  );
};

export default DeviceData;
